// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

let query = wixLocation.query; // {"ref": "yaniv"}

console.log(query.ref)
let responderlink = 'https://wixer.ravpage.co.il/form-bewixer?ref=' + query.ref;
let responderlinkm = 'https://wixer.ravpage.co.il/form-bewixer?ref=' + query.ref;

export function register_click(event) {
    //Add your code for this event here:
   
        wixLocation.to(responderlinkm);
        //wixWindow.open(responderlink);
        //$w("#button1").link = "responderlink";
        //$w('#button1').target = "_blank";
    }


$w.onReady(function () {
    //TODO: write your page related code here...

$w("#button1").onClick( (event) => {
  register_click(event);
} );

$w("#button12").onClick( (event) => {
  register_click(event);
} );

$w("#button13").onClick( (event) => {
  register_click(event);
} );

//$w("#button1").onClick( (event) => {
//  wixWindow.openLightbox("bx2020lightbox", responderlink);
//} );

//$w("#button2").onClick( (event) => {
//  wixWindow.openLightbox("bx2020lightbox", responderlink);
//} );

});